import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4db95813"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "hero-text" }
const _hoisted_2 = { class: "eyebrow" }
const _hoisted_3 = { class: "hero-title" }
const _hoisted_4 = {
  key: 0,
  class: "tagline"
}

import brand from "@/brand";


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHero',
  props: {
    title: {},
    subtitle: {},
    eyebrow: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_unref(brand).provider)
    ? (_openBlock(), _createElementBlock("section", {
        key: 0,
        class: _normalizeClass(["page-hero", { compact: !_ctx.$slots.default }])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.eyebrow || `Your ${_unref(brand).name} account`), 1),
          _createElementVNode("h1", _hoisted_3, [
            _renderSlot(_ctx.$slots, "title", {}, () => [
              _createTextVNode(_toDisplayString(_ctx.title), 1)
            ])
          ]),
          (_ctx.subtitle)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.subtitle), 1))
            : _createCommentVNode("", true)
        ]),
        _renderSlot(_ctx.$slots, "default")
      ], 2))
    : _createCommentVNode("", true)
}
}

})